import {IDataMapConfig} from '@stores'

export const dataMapperConfig: Record<'specDataMapperConfig' | 'enumDataMapperConfig', IDataMapConfig & any > = {
  specDataMapperConfig: {
    images: 'images',
    title: 'name',
    subtitle1: 'description',
    hex: 'hex',
    exId: 'exId',
    id: 'id',
    active: 'attributes.Active'
  },
  enumDataMapperConfig: {
    images: 'images',
    title: 'name',
    subtitle1: 'description',
    hex: 'hex',
    exId: 'exId',
    id: 'id'
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/constants/dataMapperConfig.ts